export default __webpack_public_path__ + "static/media/glass_door.12c4944e.JPG";